// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import BackController from "./back_controller"
application.register("back", BackController)

import Bridge__DeviceTokenController from "./bridge/device_token_controller"
application.register("bridge--device-token", Bridge__DeviceTokenController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DecimalInputController from "./decimal_input_controller"
application.register("decimal-input", DecimalInputController)

import FloatingWidgetController from "./floating_widget_controller"
application.register("floating-widget", FloatingWidgetController)

import FormErrorController from "./form_error_controller"
application.register("form-error", FormErrorController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import RecentRequestsController from "./recent_requests_controller"
application.register("recent-requests", RecentRequestsController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollableTabsController from "./scrollable_tabs_controller"
application.register("scrollable-tabs", ScrollableTabsController)

import SubtotalController from "./subtotal_controller"
application.register("subtotal", SubtotalController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
